"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-eighteen/section/whyChooseSection.tsx */

import { SmartImage } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, Key, ReactNode } from "react";

type WhyChooseSection336612sItem = {
    key: Key | null | undefined;
    /** Detected variants: "1s" | "1.5s" | "2s" | "2.5s" */
    dataWowDuration: string;
    /** Detected variants: "/Templates/Doccure/img/category/choose-icon-01.svg" | "/Templates/Doccure/img/category/choose-icon-02.svg" | "/Templates/Doccure/img/category/choose-icon-03.svg" | "/Templates/Doccure/img/category/choose-icon-04.svg" */
    src: string;
    /** Detected variants: "Licensed" | "95% Success" | "Flexible" | "Results-Driven" */
    h30Text: ReactNode;
    /** Detected variants: "Specialists" | "Rate" | "Scheduling" | "Outcomes" */
    span0Text: ReactNode;
    /** Detected variants: "15+ years average experience certifications in orthopedic & sports physiotherapy" | "Patients report significant improvement within 4-6 weeks of starting treatment" | "Same-day appointments available with evening and weekend hours your life" | "Latest treatment protocols backed by research and proven clinical outcomes" */
    p0Text: ReactNode;
    /** Detected variants: "/Templates/Doccure/img/category/choose-thumb-1.jpg" | "/Templates/Doccure/img/category/choose-thumb-2.jpg" | "/Templates/Doccure/img/category/choose-thumb-3.jpg" | "/Templates/Doccure/img/category/choose-thumb-4.jpg" */
    imageWithBasePath0Src: string;
    /** Detected variants: "/Templates/Doccure/img/category/choose-large-1.jpg" | "/Templates/Doccure/img/category/choose-large-2.jpg" | "/Templates/Doccure/img/category/choose-large-3.jpg" | "/Templates/Doccure/img/category/choose-large-4.jpg" */
    imageWithBasePath1Src: string;
    /** Detected variants: "col-xxl-3 col-xl-3 col-lg-6 col-md-6 col-sm-12 d-flex" */
    className?: string;
    /** Detected variants: "choose-item-eighteen flex-fill wow fadeInUp" */
    div0ClassName?: string;
    /** Detected variants: "choose-icon" */
    div0ClassName2?: string;
    /** Detected variants: "choose-img" */
    alt?: string;
    /** Detected variants: "img-fluid icon" */
    imageWithBasePath0ClassName?: string;
    /** Detected variants: "choose-content" */
    div1ClassName?: string;
    /** Detected variants: "custom-title" */
    h30ClassName?: string;
    /** Detected variants: "description" */
    p0ClassName?: string;
    /** Detected variants: "choose-overlay" */
    div2ClassName?: string;
    /** Detected variants: "thumb-img" */
    imageWithBasePath0Alt?: string;
    /** Detected variants: "img-fluid img-one" */
    imageWithBasePath0ClassName2?: string;
    /** Detected variants: "thumb-img" */
    imageWithBasePath1Alt?: string;
    /** Detected variants: "img-fluid img-two" */
    imageWithBasePath1ClassName?: string;
};

type WhyChooseSectionServicesSlidesItem = {
    key: Key | null | undefined;
    /** Detected variants: "Improved Mobility" | "Injury Rehabilitation" | "Muscle Strengthening" | "Personalized Treatment Plans" */
    h30Text: ReactNode;
    /** Detected variants: "services-slide" */
    className?: string;
    /** Detected variants: "title" */
    h30ClassName?: string;
};

type WhyChooseSectionServicesSlides2Item = {
    key: Key | null | undefined;
    /** Detected variants: "Preventive Healthcare" | "Personalized Treatment Plans" | "Injury Rehabilitation" | "Improved Mobility" */
    h30Text: ReactNode;
    /** Detected variants: "services-slide" */
    className?: string;
    /** Detected variants: "title" */
    h30ClassName?: string;
};
export type HomeEighteenWhyChooseSectionGeneratedProps = {
    divDiv0Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: WhyChooseSection336612sItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    divDiv0Div1H30H3Props?: Partial<ComponentProps<"h3">> | ((item: WhyChooseSection336612sItem) => Partial<ComponentProps<"h3">>);
    divDiv0Div2ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: WhyChooseSection336612sItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    divDiv0Div2ImageWithBasePath1ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: WhyChooseSection336612sItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    divH30H3Props?: Partial<ComponentProps<"h3">> | ((item: WhyChooseSectionServicesSlidesItem) => Partial<ComponentProps<"h3">>);
    whyChooseSectionServicesSlides2DivH30H3Props?: Partial<ComponentProps<"h3">> | ((item: WhyChooseSectionServicesSlides2Item) => Partial<ComponentProps<"h3">>);
    /** Default: "1s" */
    sectionDataWowDuration?: string;
    /** Default: "left" */
    sectionDiv0DivDataDirection?: string;
    /** Default: "slow" */
    sectionDiv0DivDataSpeed?: string;
    /** Default: "1s" */
    sectionDiv0Div0DivDataWowDuration?: string;
    /** Default: "WHY CHOOSE US" */
    sectionDiv0Div0Div0DivText?: ReactNode;
    /** Default: "Trusted by Hundreds" */
    sectionDiv0Div0H20H2Text?: ReactNode;
    /** Default: "of Patients" */
    sectionDiv0Div0H20H2Text2?: ReactNode;
    sectionDiv0Div0H20H2Visible?: boolean;
    sectionDiv0Div0H20H2Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0H20H2Props?: Partial<ComponentProps<"h2">>;
    /** Default: "title" */
    sectionDiv0Div0H20Span0ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/banner/title-img-1.jpg" */
    sectionDiv0Div0H20Span0ImageWithBasePath0ImageSrc?: string;
    sectionDiv0Div0H20Span0ImageWithBasePath0ImageVisible?: boolean;
    sectionDiv0Div0H20Span0ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0H20Span0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    sectionDiv0Div1ClassName?: string;
    /** Default: "right" */
    sectionDiv1DivDataDirection?: string;
    /** Default: "slow" */
    sectionDiv1DivDataSpeed?: string;
    /** Default: "shadow" */
    sectionImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/shadow-3.png" */
    sectionImageWithBasePath0ImageSrc?: string;
    sectionImageWithBasePath0ImageVisible?: boolean;
    sectionImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    whyChooseSection336612s: WhyChooseSection336612sItem[];
    whyChooseSectionServicesSlides: WhyChooseSectionServicesSlidesItem[];
    whyChooseSectionServicesSlides2: WhyChooseSectionServicesSlides2Item[];
    whyChooseSection336612sItemWrapper?: (item: WhyChooseSection336612sItem, content: ReactNode) => ReactNode;
    whyChooseSection336612sRenderer?: (defaultNode: ReactNode) => ReactNode;
    whyChooseSection336612sImageVisible?: boolean;
    whyChooseSection336612sImageRenderer?: (item: WhyChooseSection336612sItem, defaultNode: ReactNode) => ReactNode;
    whyChooseSection336612sH3Visible?: boolean;
    whyChooseSection336612sH3Renderer?: (item: WhyChooseSection336612sItem, defaultNode: ReactNode) => ReactNode;
    whyChooseSection336612sImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: WhyChooseSection336612sItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    whyChooseSection336612sH3Props?: Partial<ComponentProps<"h3">> | ((item: WhyChooseSection336612sItem) => Partial<ComponentProps<"h3">>);
    whyChooseSectionServicesSlidesItemWrapper?: (item: WhyChooseSectionServicesSlidesItem, content: ReactNode) => ReactNode;
    whyChooseSectionServicesSlidesRenderer?: (defaultNode: ReactNode) => ReactNode;
    whyChooseSectionServicesSlidesH3Visible?: boolean;
    whyChooseSectionServicesSlidesH3Renderer?: (item: WhyChooseSectionServicesSlidesItem, defaultNode: ReactNode) => ReactNode;
    whyChooseSectionServicesSlidesH3Props?: Partial<ComponentProps<"h3">> | ((item: WhyChooseSectionServicesSlidesItem) => Partial<ComponentProps<"h3">>);
    whyChooseSectionServicesSlides2ItemWrapper?: (item: WhyChooseSectionServicesSlides2Item, content: ReactNode) => ReactNode;
    whyChooseSectionServicesSlides2Renderer?: (defaultNode: ReactNode) => ReactNode;
    whyChooseSectionServicesSlides2H3Visible?: boolean;
    whyChooseSectionServicesSlides2H3Renderer?: (item: WhyChooseSectionServicesSlides2Item, defaultNode: ReactNode) => ReactNode;
    whyChooseSectionServicesSlides2H3Props?: Partial<ComponentProps<"h3">> | ((item: WhyChooseSectionServicesSlides2Item) => Partial<ComponentProps<"h3">>);
};

const HomeEighteenWhyChooseSectionGenerated: FC<HomeEighteenWhyChooseSectionGeneratedProps> = ({
    sectionDataWowDuration = "1s",
    sectionDiv0Div0Div0DivText = "WHY CHOOSE US",
    sectionDiv0Div0DivDataWowDuration = "1s",
    sectionDiv0Div0H20H2Text = "Trusted by Hundreds",
    sectionDiv0Div0H20H2Text2 = "of Patients",
    sectionDiv0Div0H20H2Visible,
    sectionDiv0Div0H20H2Renderer,
    sectionDiv0Div0H20H2Props,
    sectionDiv0Div0H20Span0ImageWithBasePath0ImageAlt = "title",
    sectionDiv0Div0H20Span0ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/banner/title-img-1.jpg",
    sectionDiv0Div0H20Span0ImageWithBasePath0ImageVisible,
    sectionDiv0Div0H20Span0ImageWithBasePath0ImageRenderer,
    sectionDiv0Div0H20Span0ImageWithBasePath0ImageProps,
    sectionDiv0DivDataDirection = "left",
    sectionDiv0DivDataSpeed = "slow",
    sectionDiv1DivDataDirection = "right",
    sectionDiv1DivDataSpeed = "slow",
    sectionImageWithBasePath0ImageAlt = "shadow",
    sectionImageWithBasePath0ImageSrc = "/Templates/Doccure/img/bg/shadow-3.png",
    sectionImageWithBasePath0ImageVisible,
    sectionImageWithBasePath0ImageRenderer,
    sectionImageWithBasePath0ImageProps,
    divDiv0Div0ImageWithBasePath0ImageProps,
    divDiv0Div1H30H3Props,
    divDiv0Div2ImageWithBasePath0ImageProps,
    divDiv0Div2ImageWithBasePath1ImageProps,
    divH30H3Props,
    whyChooseSectionServicesSlides2DivH30H3Props,
    sectionDiv0Div1ClassName,
    whyChooseSection336612s,
    whyChooseSectionServicesSlides,
    whyChooseSectionServicesSlides2,
    whyChooseSection336612sItemWrapper,
    whyChooseSection336612sRenderer,
    whyChooseSection336612sImageVisible,
    whyChooseSection336612sImageRenderer,
    whyChooseSection336612sH3Visible,
    whyChooseSection336612sH3Renderer,
    whyChooseSection336612sImageProps,
    whyChooseSection336612sH3Props,
    whyChooseSectionServicesSlidesItemWrapper,
    whyChooseSectionServicesSlidesRenderer,
    whyChooseSectionServicesSlidesH3Visible,
    whyChooseSectionServicesSlidesH3Renderer,
    whyChooseSectionServicesSlidesH3Props,
    whyChooseSectionServicesSlides2ItemWrapper,
    whyChooseSectionServicesSlides2Renderer,
    whyChooseSectionServicesSlides2H3Visible,
    whyChooseSectionServicesSlides2H3Renderer,
    whyChooseSectionServicesSlides2H3Props,
}) => {
    return (
        <>
            <section className="section whychoose-section-eighteen">
                <div className="container">
                    <div className="section-header-eighteen wow fadeInDown" data-wow-duration={sectionDiv0Div0DivDataWowDuration}>
                        <div className="sub-title">{sectionDiv0Div0Div0DivText}</div>
                        {renderNode(sectionDiv0Div0H20H2Visible, sectionDiv0Div0H20H2Renderer, (
                            <h2 className="section-title" {...(sectionDiv0Div0H20H2Props ?? {})}>
                                {sectionDiv0Div0H20H2Text}
                                <br />
                                <span className="title-img">
                                    {renderNode(sectionDiv0Div0H20Span0ImageWithBasePath0ImageVisible, sectionDiv0Div0H20Span0ImageWithBasePath0ImageRenderer, (
                                        <SmartImage src={sectionDiv0Div0H20Span0ImageWithBasePath0ImageSrc} alt={sectionDiv0Div0H20Span0ImageWithBasePath0ImageAlt} className="img-fluid" {...(sectionDiv0Div0H20Span0ImageWithBasePath0ImageProps ?? {})} />
                                    ))}
                                </span>
                                {sectionDiv0Div0H20H2Text2}
                            </h2>
                        ))}
                    </div>
                    <div className={sectionDiv0Div1ClassName ?? "row row-gap-4"}>
                        {renderCollectionNode(
                            whyChooseSection336612s,
                            (item: WhyChooseSection336612sItem) => (
                                <div className={item.className ?? "col-xxl-3 col-xl-3 col-lg-6 col-md-6 col-sm-12 d-flex"} key={item.key}>
                                    <div className={item.div0ClassName ?? "choose-item-eighteen flex-fill wow fadeInUp"} data-wow-duration={item.dataWowDuration}>
                                        <div className={item.div0ClassName2 ?? "choose-icon"}>
                                            {renderItemNode(whyChooseSection336612sImageVisible, whyChooseSection336612sImageRenderer, item, (
                                                <SmartImage src={item.src} alt={item.alt ?? "choose-img"} className={item.imageWithBasePath0ClassName ?? "img-fluid icon"} {...(typeof whyChooseSection336612sImageProps === "function" ? whyChooseSection336612sImageProps(item) : (whyChooseSection336612sImageProps ?? {}))} {...(typeof divDiv0Div0ImageWithBasePath0ImageProps === "function" ? divDiv0Div0ImageWithBasePath0ImageProps(item) : (divDiv0Div0ImageWithBasePath0ImageProps ?? {}))} />
                                            ))}
                                        </div>
                                        <div className={item.div1ClassName ?? "choose-content"}>
                                            {renderItemNode(whyChooseSection336612sH3Visible, whyChooseSection336612sH3Renderer, item, (
                                                <h3 className={item.h30ClassName ?? "custom-title"} {...(typeof whyChooseSection336612sH3Props === "function" ? whyChooseSection336612sH3Props(item) : (whyChooseSection336612sH3Props ?? {}))} {...(typeof divDiv0Div1H30H3Props === "function" ? divDiv0Div1H30H3Props(item) : (divDiv0Div1H30H3Props ?? {}))}>
                                                    {item.h30Text}
                                                    <span>{item.span0Text}</span>
                                                </h3>
                                            ))}
                                            <p className={item.p0ClassName ?? "description"}>{item.p0Text}</p>
                                        </div>
                                        <div className={item.div2ClassName ?? "choose-overlay"}>
                                            {renderItemNode(whyChooseSection336612sImageVisible, whyChooseSection336612sImageRenderer, item, (
                                                <SmartImage src={item.imageWithBasePath0Src} alt={item.imageWithBasePath0Alt ?? "thumb-img"} className={item.imageWithBasePath0ClassName2 ?? "img-fluid img-one"} {...(typeof whyChooseSection336612sImageProps === "function" ? whyChooseSection336612sImageProps(item) : (whyChooseSection336612sImageProps ?? {}))} {...(typeof divDiv0Div2ImageWithBasePath0ImageProps === "function" ? divDiv0Div2ImageWithBasePath0ImageProps(item) : (divDiv0Div2ImageWithBasePath0ImageProps ?? {}))} />
                                            ))}
                                            {renderItemNode(whyChooseSection336612sImageVisible, whyChooseSection336612sImageRenderer, item, (
                                                <SmartImage src={item.imageWithBasePath1Src} alt={item.imageWithBasePath1Alt ?? "thumb-img"} className={item.imageWithBasePath1ClassName ?? "img-fluid img-two"} {...(typeof whyChooseSection336612sImageProps === "function" ? whyChooseSection336612sImageProps(item) : (whyChooseSection336612sImageProps ?? {}))} {...(typeof divDiv0Div2ImageWithBasePath1ImageProps === "function" ? divDiv0Div2ImageWithBasePath1ImageProps(item) : (divDiv0Div2ImageWithBasePath1ImageProps ?? {}))} />
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            ),
                            whyChooseSection336612sItemWrapper,
                            whyChooseSection336612sRenderer
                        )}
                    </div>
                </div>
                {renderNode(sectionImageWithBasePath0ImageVisible, sectionImageWithBasePath0ImageRenderer, (
                    <SmartImage src={sectionImageWithBasePath0ImageSrc} alt={sectionImageWithBasePath0ImageAlt} className="img-fluid element-one" {...(sectionImageWithBasePath0ImageProps ?? {})} />
                ))}
            </section>
            <section className="slider-section pb-0 wow fadeInUp" data-wow-duration={sectionDataWowDuration}>
                <div className="horizontal-slide slide-eighteen bg-primary d-flex" data-direction={sectionDiv0DivDataDirection} data-speed={sectionDiv0DivDataSpeed}>
                    <div className="slide-list d-flex gap-4">
                        {renderCollectionNode(
                            whyChooseSectionServicesSlides,
                            (item: WhyChooseSectionServicesSlidesItem) => (
                                <div className={item.className ?? "services-slide"} key={item.key}>
                                    {renderItemNode(whyChooseSectionServicesSlidesH3Visible, whyChooseSectionServicesSlidesH3Renderer, item, (
                                        <h3 className={item.h30ClassName ?? "title"} {...(typeof whyChooseSectionServicesSlidesH3Props === "function" ? whyChooseSectionServicesSlidesH3Props(item) : (whyChooseSectionServicesSlidesH3Props ?? {}))} {...(typeof divH30H3Props === "function" ? divH30H3Props(item) : (divH30H3Props ?? {}))}>{item.h30Text}</h3>
                                    ))}
                                </div>
                            ),
                            whyChooseSectionServicesSlidesItemWrapper,
                            whyChooseSectionServicesSlidesRenderer
                        )}
                    </div>
                </div>
                <div className="horizontal-slide slide-eighteen bg-secondary d-flex" data-direction={sectionDiv1DivDataDirection} data-speed={sectionDiv1DivDataSpeed}>
                    <div className="slide-list d-flex gap-4">
                        {renderCollectionNode(
                            whyChooseSectionServicesSlides2,
                            (item: WhyChooseSectionServicesSlides2Item) => (
                                <div className={item.className ?? "services-slide"} key={item.key}>
                                    {renderItemNode(whyChooseSectionServicesSlides2H3Visible, whyChooseSectionServicesSlides2H3Renderer, item, (
                                        <h3 className={item.h30ClassName ?? "title"} {...(typeof whyChooseSectionServicesSlides2H3Props === "function" ? whyChooseSectionServicesSlides2H3Props(item) : (whyChooseSectionServicesSlides2H3Props ?? {}))} {...(typeof whyChooseSectionServicesSlides2DivH30H3Props === "function" ? whyChooseSectionServicesSlides2DivH30H3Props(item) : (whyChooseSectionServicesSlides2DivH30H3Props ?? {}))}>{item.h30Text}</h3>
                                    ))}
                                </div>
                            ),
                            whyChooseSectionServicesSlides2ItemWrapper,
                            whyChooseSectionServicesSlides2Renderer
                        )}
                    </div>
                </div>
            </section>
        </>
    );
};

export default HomeEighteenWhyChooseSectionGenerated;
